export class EntrepriseTLR {
	id!: number;
	fe!: boolean;
	adresseCodePostal!: string;
	adresseRue!: string;
	adresseVille!: string;
	nom!: string;
	siret!: string;
	obsolete!: boolean;
	antenneId!: number;
	refGmao!: string;
	raisonSociale!: string;
	documentApplicable!: string;
	constructor() {
	}
}